import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=07cf5bed&scoped=true&lang=pug"
import script from "./QR.vue?vue&type=script&lang=js"
export * from "./QR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf5bed",
  null
  
)

export default component.exports